import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { CdkDragHandle } from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { MatMenuModule } from '@angular/material/menu';
import { FiDatePickerModule } from '@fi-shared/fi-date-picker';
import { FiTwoColumnsContainerModule } from '@fi-shared/fi-two-columns-container/fi-two-columns-container.module';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { InfoIconModule } from '@fi-shared/info-icon/info-icon.module';
import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';
import { FiChecklist2ReportOpenChecklistModule } from '../open-checklists-report/open-checklists-report.module';
import { FiChecklistHistoryDeviationsChart } from '../../components/checklist-history-report/history-deviations-chart/checklist-history-deviations-chart.component';
import { FiChecklistHistoryReportComponent } from './checklist-history-report.component';
import { FiChecklist2ReportChecklistsSummaryTableWrapperComponent } from '@fi-shared/checklist/fi-checklist2-report/components/checklist-history-report/history-checklists-summary-table-wrapper/checklists-summary-table-wrapper.component';
import { FiChecklist2ReportHistoryWidget } from '../../components/checklist-history-report/history-widget/history-widget.component';
import { FiHistoryChartComponent } from '../../components/checklist-history-report/history-chart/history-chart.component';
import { FiHistoryChecklistDetailsComponent } from '@fi-shared/checklist/fi-checklist2-report/components/checklist-history-report/checklist-details/history-checklist-details/history-checklist-details.component';
import { FiHistoryChecklistUnitsTableComponent } from '@fi-shared/checklist/fi-checklist2-report/components/checklist-history-report/checklist-details/history-checklist-units-table/history-checklist-units-table.component';
import { FiHistoryChecklistDetailsWrapperComponent } from '@fi-shared/checklist/fi-checklist2-report/components/checklist-history-report/checklist-details/history-checklist-details-wrapper.component';
import { FiHistoryChecklistsSummaryTable } from '@fi-shared/checklist/fi-checklist2-report/components/checklist-history-report/history-checklists-summary-table-wrapper/checklists-summary-table/checklists-summary-table.component';
import { FiChecklist2ReportSharedModule } from '../../components/shared/checklist-report-shared.module';
import { FiHistoryChecklistDetailsUnitPerformanceMetricsComponent } from '@fi-shared/checklist/fi-checklist2-report/components/checklist-history-report/checklist-details/unit-performance-metrics/unit-performance-metrics.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { FormsModule } from '@angular/forms';
import { FiHistoryChecklistDetailedAnswersComponent } from '@fi-shared/checklist/fi-checklist2-report/components/checklist-history-report/checklist-details/detailed-answers/detailed-answers.component';
import { FiPaginatorModule } from '@fi-shared/fi-paginator/fi-paginator.module';
import { FiChecklist2ReportColumnDefsModule } from '@fi-shared/checklist/fi-checklist2-report/fi-checklist2-report-column-defs/fi-checklist2-report-column-defs.module';
import { FiHistoryChecklistDetailsAnswersDownloadDialogComponent } from '@fi-shared/checklist/fi-checklist2-report/components/checklist-history-report/checklist-details/answers-download-dialog/answers-download-dialog.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FiChecklist2ListColumnDefsModule } from '@fi-shared/checklist/fi-checklist2-list-column-defs/fi-checklist2-list-column-defs.module';
import { FiChecklistHistoryBenchmarkItemDetailedReportButtonComponent } from '@fi-shared/checklist/fi-checklist2-report/components/checklist-history-report/unit-performance-benchmark/benchmark-item-detailed-report-button/fi-benchmark-item-detailed-report-button.component';
import { FiHistoryChecklistDetailsUnitPerformanceBenchmarkComponent } from '@fi-shared/checklist/fi-checklist2-report/components/checklist-history-report/unit-performance-benchmark/history-checklist-details-unit-performance-benchmark.component';
import { FiChecklistHistoryChecklistsBenchmarkComponent } from '@fi-shared/checklist/fi-checklist2-report/components/checklist-history-report/unit-performance-benchmark/checklists-benchmark/checklists-benchmark.component';
import { FiChecklistHistoryCheckpointsBenchmarkComponent } from '@fi-shared/checklist/fi-checklist2-report/components/checklist-history-report/unit-performance-benchmark/checkpoints-benchmark/checkpoints-benchmark.component';
import { FiChecklistHistoryUnitBenchmarkChartComponent } from '@fi-shared/checklist/fi-checklist2-report/components/checklist-history-report/unit-performance-benchmark/unit-benchmark-chart/unit-benchmark-chart.component';
import { FiChecklistHistoryBenchmarkItemInfoTooltipComponent } from '@fi-shared/checklist/fi-checklist2-report/components/checklist-history-report/unit-performance-benchmark/benchmark-item-info-tooltip/benchmark-item-info-tooltip.component';
import { FiChecklistHistoryCheckpointGroupsBenchmarkComponent } from '@fi-shared/checklist/fi-checklist2-report/components/checklist-history-report/unit-performance-benchmark/checkpoint-groups-benchmark/checkpoint-groups-benchmark.component';
import { FiChecklistHistoryComplianceChart } from '@fi-shared/checklist/fi-checklist2-report/components/checklist-history-report/history-chart-non-compliance/history-chart-non-compliance.component';
import { FiChartModule } from '@fi-shared/fi-chart/fi-chart.module';
import { FiReportWidgetModule } from '@fi-shared/fi-report-widget/fi-report-widget.module';
import { FiTimeRangeMenuModule } from '@fi-shared/fi-time-range-menu/fi-time-range-menu.module';
import { FiReportPieChartModule } from '@fi-shared/fi-report-pie-chart/fi-report-pie-chart.module';

@NgModule({
    imports: [
        CommonModule,
        MatCardModule,
        CdkDragHandle,
        MatIconModule,
        MatButtonModule,
        FiAppTextSharedModule,
        FiLoadingModule,
        MatMenuModule,
        FiDatePickerModule,
        FiChecklist2ReportSharedModule,
        FiTwoColumnsContainerModule,
        FiWrapperTableModule,
        FiChecklist2ReportOpenChecklistModule,
        FiPaginatorModule,
        InfoIconModule,
        FiFormatDateModule,
        FiChartModule,
        MatButtonToggleModule,
        FormsModule,
        FiChecklist2ReportColumnDefsModule,
        MatRadioModule,
        MatProgressBarModule,
        FiChecklist2ListColumnDefsModule,
        FiReportWidgetModule,
        FiTimeRangeMenuModule,
        FiReportPieChartModule,
    ],
    declarations: [
        FiChecklist2ReportHistoryWidget,
        FiChecklistHistoryDeviationsChart,
        FiHistoryChartComponent,
        FiChecklistHistoryReportComponent,
        FiHistoryChecklistsSummaryTable,
        FiChecklist2ReportChecklistsSummaryTableWrapperComponent,
        FiHistoryChecklistDetailsWrapperComponent,
        FiHistoryChecklistUnitsTableComponent,
        FiHistoryChecklistDetailsComponent,
        FiHistoryChecklistDetailsUnitPerformanceBenchmarkComponent,
        FiHistoryChecklistDetailsUnitPerformanceMetricsComponent,
        FiChecklistHistoryChecklistsBenchmarkComponent,
        FiChecklistHistoryCheckpointGroupsBenchmarkComponent,
        FiChecklistHistoryCheckpointsBenchmarkComponent,
        FiChecklistHistoryUnitBenchmarkChartComponent,
        FiChecklistHistoryBenchmarkItemInfoTooltipComponent,
        FiHistoryChecklistDetailedAnswersComponent,
        FiHistoryChecklistDetailsAnswersDownloadDialogComponent,
        FiChecklistHistoryBenchmarkItemDetailedReportButtonComponent,
        FiChecklistHistoryComplianceChart,
    ],
    exports: [
        FiHistoryChecklistDetailsWrapperComponent,
        FiChecklist2ReportChecklistsSummaryTableWrapperComponent,
        FiChecklist2ReportHistoryWidget,
        FiChecklistHistoryReportComponent,
    ],
})
export class FiChecklist2ReportChecklistHistoryModule {}
